export default __webpack_public_path__ + "static/media/timesheets.dbc481f6.svg";